import React, { useState } from "react";

function OrderItemsModel({ data, userType }: any) {
  const [modalVisible, setModalVisible] = useState<boolean>();
  return (
    <>
      <div
        className="modal"
        style={{ display: modalVisible ? "block" : "none" }}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className={"d-flex justify-content-between align-items-center"}
                style={{ width: "100%" }}>
                <h5 className={"mb-0"}>ORDER ITEMS</h5>
                <button
                  className={"btn btn-secondary btn-sm m-0"}
                  onClick={() => setModalVisible(false)}>
                  <i className={"fa fa-close"} style={{ fontSize: 20 }}></i>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className={"table-responsive"}>
                <table className={"border w-full"} style={{ width: "100%" }}>
                  <thead>
                    <tr className={"border"}>
                      <th className={"border"}>S.No.</th>
                      <th className={"border"}>Product Name</th>
                      <th className={"border"}>Product Code</th>
                      <th className={"border"}>Price</th>
                      <th className={"border"}>Qty</th>
                      <th className={"border"}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((d: any, index: number) => {
                      return (
                        <tr>
                          <td className={"border"}>{index + 1}</td>
                          <td className={"border"}>{d.product_name}</td>
                          <td className={"border"}>{d.product_code}</td>
                          <td className={"border"}>
                            Rs.{" "}
                            {userType === "SELLER"
                              ? d.landing_cost
                              : d.sell_price}
                          </td>
                          <td className={"border"}>{d.supply_qty}</td>
                          <td className={"border"}>
                            Rs.{" "}
                            {(
                              (userType === "SELLER"
                                ? d.landing_cost
                                : d.sell_price) * d.supply_qty
                            )?.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className={"btn btn-info btn-sm"}
        onClick={() => setModalVisible(true)}>
        Show
      </button>
    </>
  );
}

export default OrderItemsModel;
